import axios, { AxiosResponse } from 'axios';
import { DashboardRepository } from '../../Domain/Repositories/DashboardRepository';
import { Dashboard } from '../../Model/Dashboard';
import { Notice } from '../../../Notice/Model/Notice';
import { store } from '../../../Presentation/store';

function normalizeList<T>(data: T[] | { results?: T[] }): T[] {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.results)) return data.results;
  return [];
}

export class DashboardRepositoryImpl implements DashboardRepository {
  private http = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/json' },
  });

  constructor() {
    this.http.interceptors.request.use((config) => {
      const reduxToken  = store.getState().auth.access;
      const localToken  = localStorage.getItem("access");
      const token       = reduxToken ?? localToken;
      if (token) config.headers.Authorization = `Bearer ${token}`;
      return config;
    });
  }

  getSummary(): Promise<Dashboard> {
    return this.http
      .get<Dashboard>('/dashboard/summary/')
      .then((r: AxiosResponse<Dashboard>) => r.data);
  }

  getRecentNotices(): Promise<Notice[]> {
    return this.http
      .get<Notice[] | { results?: Notice[] }>('/dashboard/notices/')
      .then((r: AxiosResponse<Notice[] | { results?: Notice[] }>) =>
        normalizeList(r.data),
      );
  }
}
